"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSACTIONS_PRODUCT = exports.IDENTITY_PRODUCT = exports.AUTH_PRODUCT = exports.PROD_ENV = exports.SANDBOX_ENV = exports.DEV_ENV = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEV_ENV = "development";
var SANDBOX_ENV = "sandbox";
var PROD_ENV = "production";
var AUTH_PRODUCT = "auth";
var TRANSACTIONS_PRODUCT = "transactions";
var IDENTITY_PRODUCT = "identity";
// We use this to handle open/loaded to prevent unnecessary re-rendering

var ReactPlaid = function (_Component) {
  _inherits(ReactPlaid, _Component);

  function ReactPlaid() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlaid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlaid.__proto__ || Object.getPrototypeOf(ReactPlaid)).call.apply(_ref, [this].concat(args))), _this), _this.loaded = false, _this.open = false, _this.handleOpen = function () {
      _this.open = true;
      if (_this.loaded) {
        _this.linkHandler.open(_this.props.institution);
        _this.props.onOpen();
      }
    }, _this.handleLoad = function () {
      _this.loaded = true;
      _this.props.onLoad();
      if (_this.open) _this.handleOpen();
    }, _this.handleSuccess = function (publicToken, metaData) {
      _this.props.onSuccess(publicToken, metaData);
    }, _this.handleExit = function () {
      _this.open = false;
      _this.props.onExit();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlaid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.linkHandler = Plaid.create({
        apiVersion: this.props.apiVersion,
        clientName: this.props.clientName,
        product: this.props.product,
        key: this.props.apiKey,
        env: this.props.env,
        selectAccount: this.props.selectAccount,
        onLoad: this.handleLoad,
        onSuccess: this.handleSuccess,
        onExit: this.handleExit
      });

      this.props.onLoading();
      if (this.props.open) this.handleOpen();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.open && !prevProps.open) {
        this.handleOpen();
      } else if (prevProps.open && !this.props.open) {
        // Close?
        // Plaid provides no method to close :(
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return ReactPlaid;
}(_react.Component);

ReactPlaid.propTypes = {
  open: _propTypes2.default.bool,
  clientName: _propTypes2.default.string.isRequired,
  env: _propTypes2.default.oneOf([DEV_ENV, SANDBOX_ENV, PROD_ENV]).isRequired,
  institution: _propTypes2.default.string,
  apiKey: _propTypes2.default.string.isRequired,
  product: _propTypes2.default.array.isRequired,
  token: _propTypes2.default.string,
  selectAccount: _propTypes2.default.bool,
  webhook: _propTypes2.default.string,
  onSuccess: _propTypes2.default.func.isRequired,
  onExit: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  onLoading: _propTypes2.default.func,
  onOpen: _propTypes2.default.func
};
ReactPlaid.defaultProps = {
  apiVersion: "v2",
  onExit: function onExit() {},
  onSuccess: function onSuccess() {},
  onLoad: function onLoad() {},
  onLoading: function onLoading() {},
  onOpen: function onOpen() {}
};
exports.default = ReactPlaid;
exports.DEV_ENV = DEV_ENV;
exports.SANDBOX_ENV = SANDBOX_ENV;
exports.PROD_ENV = PROD_ENV;
exports.AUTH_PRODUCT = AUTH_PRODUCT;
exports.IDENTITY_PRODUCT = IDENTITY_PRODUCT;
exports.TRANSACTIONS_PRODUCT = TRANSACTIONS_PRODUCT;


//////////////////
// WEBPACK FOOTER
// ./~/react-plaid/lib/index.js
// module id = 1498
// module chunks = 0